/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { FormattedNumber } from "react-intl";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "Actions";
import classnames from "classnames";
import Modal from "Utils/Modal";
import CurrencyInput from "Utils/CurrencyInput";
import Radio from "Utils/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropayBankForm from "Components/profile/bankAccounts/PropayBankForm";
import { MakeAPayment } from "Utils/SvgIcons";
import validations from "HelperFunctions/validations";
import { toNumber } from "HelperFunctions/general";
import ScrollArea from "Utils/react-scrollbar";
import CurrencyLabel from "Utils/CurrencyLabel";
import WorldpayBankForm from "Components/profile/bankAccounts/WorldpayBankForm";
import WorldpayHostedPaymentModal from "Components/profile/creditCards/WorldpayHostedPaymentModal";
import StripeSecureCardModal from "Components/profile/creditCards/StripeSecureCardModal";
import StandardSelectField from "Utils/redux_form_inputs/StandardSelectField";
import SurchargeNotice from 'Components/cart/SurchargeNotice';

class ConnectPaymentBox extends React.Component {
  state = {
    paymentSelection: "new_credit_card",
    transaction: { card_token: "", payment_type: "new_credit_card" },
    open: false,
    successOpen: false,
    successRefundOpen: false,
    errors: {},
    loading: false,
    new_card: null,
    new_bank: null,
    amountType: "",
    customAmount: "",
    worldpayModalOpen: false,
    stripeModalOpen: false,
    cardNickname: "",
    /** Cards added this session only (guest does not see saved cards from profile) */
    sessionCreditCards: []
  };

  componentDidMount() {
    const { rental } = this.props;
    let amountType;
    if (!rental.hasDeposit) {
      amountType = "amountDue";
    } else {
      if (rental.amountRemaining > 0) {
        amountType = "amountRemaining";
      } else {
        amountType = "";
      }
    }
    this.setState({
      amountType: amountType,
      customAmount: this.getPaymentAmount(amountType)
    });
  }

  componentWillReceiveProps(nextProps) {
    const { rental } = nextProps;
    if (
      rental.hasDeposit !== this.props.rental.hasDeposit ||
      rental.amountRemaining !== this.props.rental.amountRemaining
    ) {
      let amountType;
      if (!rental.hasDeposit) {
        amountType = "amountDue";
      } else {
        if (rental.amountRemaining > 0) {
          amountType = "amountRemaining";
        } else {
          amountType = "";
        }
      }
      this.setState({
        amountType: amountType,
        customAmount: this.getPaymentAmount(amountType)
      });
    }
  }

  isOnlyLetters = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^[a-zA-Z]+$/.test(strWithoutSpaces);
  };

  isOnlyNumbers = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^\d+$/.test(strWithoutSpaces);
  }

  validate = () => {
    const errors = {};
    const { rental } = this.props;
    const amountDue = rental.amountRemaining;
    const { paymentSelection, transaction, customAmount, new_card, sessionCreditCards } = this.state;
    if (paymentSelection === "credit_card") {
      if (validations.required(transaction?.card_token, true)) {
        errors.body = "Please select a credit card.";
      }
    }
    if (
      paymentSelection === "new_credit_card" &&
      [ "worldpay", "launchpay", "stripe" ].includes(rental?.paymentProcessor) &&
      sessionCreditCards?.length === 0 &&
      !new_card
    ) {
      errors.body = "Please add a credit card using the button above.";
    }
    if (
      paymentSelection === "bank" &&
      validations.required(transaction?.bank_token, true)
    ) {
      errors.body = "Please select a bank account.";
    }
    if (customAmount > amountDue || customAmount < 0) {
      errors.body = "The Custom Amount you entered is invalid!";
    }
    return errors;
  };

  validateMerchantAccount = (location, paymentProcessor) => {
    const error = {};
    if (location.isOnTrial) {
      error.merchantAccount = 'Location is on trial and cannot accept payments';
    }
    if (
      paymentProcessor == 'stripe' &&
      !location.hasStripeAuthentication
    ) {
      error.merchantAccount = 'Merchant account is not setup for Stripe';
    }
    if (
      paymentProcessor == 'propay' &&
      !location.hasPropayAuthentication
    ) {
      error.merchantAccount = 'Merchant account is not setup for Propay';
    }
    if (
      (paymentProcessor == 'worldpay' || paymentProcessor == 'launchpay') &&
      !location.hasWorldpayAuthentication
    ) {
      error.merchantAccount = 'Merchant account is not setup.';
    }

    return error;
  }

  validateTransactionAmountAndType = (transaction, amount) => {
    const error = {};
    const { payment_type } = transaction;
    const cardTypes = ['new_credit_card', 'credit_card'];

    if (amount <= 0) {
      error.noAmount = 'Charge amount must be greater than 0.';
    }

    if (cardTypes.includes(payment_type) && amount < 0.5) {
      error.amount = 'The minimum charge is $0.50.';
    } else if (payment_type === 'new_bank' && amount < 1.5) {
      error.amount = 'The minimum bank charge is $1.50.';
    }

    return error;
  }

  validateNewBank = (newBank) => {
    const errors = {};
    const { account_number, bank_number, first_name, last_name } = newBank;

    if (!account_number) {
      errors.accountNumber = 'Account number cannot be blank.';
    }
    if (!this.isOnlyNumbers(account_number)) {
      errors.accountNumber = 'Account number must contain only numbers.'
    }
    if (!bank_number) {
      errors.bankNumber = 'Routing number cannot be blank.';
    }
    if (!this.isOnlyNumbers(bank_number)) {
      errors.notNumber = 'Routing number must contain only numbers.'
    }
    if (bank_number.length !== 9) {
      errors.bankNumber = 'Routing number must be 9 digits.';
    }
    if (!this.isOnlyLetters(first_name) || !this.isOnlyLetters(last_name)) {
      errors.accountName = 'Account name must be letters only.';
    }

    return errors;
  }

  validatePayments = (transaction, location, paymentProcessor) => {
    const error = {};
    const { payment_type } = transaction;
    const { hasWorldpayAuthentication } = location;
    const types = ['credit_card', 'new_credit_card'];

    if (
      types.includes(payment_type) &&
      !hasWorldpayAuthentication &&
      (paymentProcessor == 'worldpay' || paymentProcessor == 'launchpay')
    ) {
      error.paymentError =
        `This businesss isn't ready to accept ${paymentProcessor} payments.`;
    }
    if (payment_type === 'new_bank' && !hasWorldpayAuthentication) {
      error.paymentError = "This business isn't ready to accept bank payments.";
    }

    return error;
  };

  validateCardType = (cardType) => {
    const error = {};

    if (cardType === 'Select Card Type') {
      error.cardType = 'A card type must be selected.';
    }

    return error;
  }

  validateBankType = (paymentMethodType, checkType, companyName) => {
    const error = {};

    if (paymentMethodType === 'Select Payment Method Type') {
      error.bankType = 'You must select an account type.';
    }
    if (checkType === 'Check Type') {
      error.checkType = 'You must select a check type.';
    }
    if (checkType === 'Business' && !companyName) {
      error.companyName = 'Please enter a Company name.';
    }

    return error;
  }

  buildRailsObject = () => {
    const { paymentSelection } = this.state;
    const isCardPayment = paymentSelection === "new_credit_card" || paymentSelection === "credit_card";
    if (isCardPayment) {
      return this.buildCardRailsObject();
    }
    return this.buildBankRailsObject();
  };

  buildCardRailsObject = () => {
    const { new_card, customAmount, paymentSelection, transaction, sessionCreditCards } = this.state;
    const { rental, location, customer, customerType } = this.props;

    let primaryContact;

    if (rental.companyRentalRelationship == null) {
      primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true)
    } else {
      if (rental.companyRentalRelationship.isPrimaryContact == true) {
        primaryContact = rental.companyRentalRelationship
      } else {
        primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true)
      }
    }

    const isSessionCardSelected = paymentSelection === "credit_card" && transaction?.card_token;
    const selectedSessionCard = isSessionCardSelected
      ? sessionCreditCards?.find((c) => c.token === transaction.card_token)
      : null;

    // Session cards were already saved via POST /credit_cards (Worldpay or Stripe modal). Charge the existing card by token.
    const useExistingCard = isSessionCardSelected && selectedSessionCard;
    const effectiveCard = useExistingCard ? null : new_card;
    const paymentType = useExistingCard ? "credit_card" : "new_credit_card";
    const payerName =
      (customerType === "Company"
        ? customer?.name
        : [customer?.firstName, customer?.lastName].filter(Boolean).join(" ")
      ) || "Guest";

    return {
      new_card: effectiveCard,
      transaction: {
        amount: customAmount,
        payment_type: paymentType,
        ...(useExistingCard && transaction?.card_token ? { card_token: transaction.card_token } : {}),
        payment_source: customer?.id != null ? "guest" : "true_guest",
        customer_id: primaryContact?.clientId ?? primaryContact?.companyId,
        customer_type: primaryContact?.clientType ?? "Company",
        metadata: { payer_name: payerName }
      },
      billing_note: {
        author_name: payerName,
        message: "From Storefront",
        note_type: "Payment"
      },
      location_id: location.id,
      send_receipt: true
    };
  };
  buildBankRailsObject() {
    const { new_bank, customAmount } = this.state;
    const { rental, location, customer, customerType } = this.props;

    let primaryContact;

    if (rental.companyRentalRelationship == null) {
      primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true)
    } else {
      if (rental.companyRentalRelationship.isPrimaryContact == true) {
        primaryContact = rental.companyRentalRelationship
      } else {
        primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true)
      }
    }

    const bankHolder =
      (customerType === "Company"
        ? customer?.name
        : [customer?.firstName, customer?.lastName].filter(Boolean).join(" ")
      ) || [new_bank?.first_name, new_bank?.last_name].filter(Boolean).join(" ") ||
      new_bank?.name || "Guest";

    return {
      new_bank,
      transaction: {
        amount: customAmount,
        payment_type: "new_bank",
        payment_source: customer.id != undefined ? "guest" : "true_guest",
        customer_id: primaryContact?.clientId ? primaryContact?.clientId : primaryContact?.companyId,
        customer_type: primaryContact?.clientType ? primaryContact?.clientType : "Company",
        metadata: { payer_name: bankHolder }
      },
      billing_note: {
        author_name: bankHolder,
        message: "From Storefront",
        note_type: "Payment"
      },
      location_id: location.id,
      send_receipt: true
    };
  }

  handleTransactionChange = (event) => {
    const { value } = event.target;
    const { sessionCreditCards, transaction } = this.state;
    if (value === "new_credit_card") {
      this.setState({
        paymentSelection: "new_credit_card",
        transaction: { ...transaction, card_token: "", payment_type: "new_credit_card" },
        new_card: null
      });
    } else {
      const sessionCard = sessionCreditCards?.find((c) => c.token === value);
      if (sessionCard) {
        this.setState({
          paymentSelection: "credit_card",
          transaction: { ...transaction, card_token: value, payment_type: "credit_card" },
          new_card: {
            payment_account_id: sessionCard.payment_account_id,
            worldpay_transaction_id: sessionCard.worldpay_transaction_id,
            last_four: sessionCard.last4 ?? sessionCard.last_four,
            name: sessionCard.name,
            stripe_token: sessionCard.stripe_token
          }
        });
      }
    }
  };

  toggleWorldpayModal = () => {
    this.setState((prev) => ({ worldpayModalOpen: !prev.worldpayModalOpen }));
  };

  toggleStripeModal = () => {
    this.setState((prev) => ({ stripeModalOpen: !prev.stripeModalOpen }));
  };

  handleWorldpayCardSaved = (savedCard) => {
    const card = savedCard?.creditCard || savedCard;
    const cardToken = card?.token || savedCard?.payment_account_id;
    const paymentAccountId = card?.payment_account_id ?? cardToken;
    const lastFour = card?.last_four ?? card?.last4;
    if (cardToken) {
      const sessionCard = {
        token: cardToken,
        last4: lastFour,
        cardType: card?.card_type ?? card?.cardType ?? "Card",
        name: card?.name ?? "Guest",
        binType: card?.bin_type ?? card?.binType ?? savedCard?.bin_type ?? savedCard?.binType ?? 'credit',
        payment_account_id: paymentAccountId,
        worldpay_transaction_id: card?.worldpay_transaction_id ?? savedCard?.transaction_id
      };
      this.setState((prev) => ({
        sessionCreditCards: [...(prev.sessionCreditCards || []), sessionCard],
        paymentSelection: "credit_card",
        transaction: { ...prev.transaction, card_token: cardToken, payment_type: "credit_card" },
        new_card: {
          payment_account_id: paymentAccountId,
          worldpay_transaction_id: sessionCard.worldpay_transaction_id,
          last_four: lastFour,
          name: sessionCard.name
        }
      }));
    }
    this.toggleWorldpayModal();
  };

  handleStripeCardSaved = (savedCard) => {
    // Normalize: API may return card at top level or nested (e.g. credit_card / creditCard / data)
    const card = savedCard?.credit_card ?? savedCard?.creditCard ?? savedCard?.data ?? savedCard;
    const cardToken = card?.token ?? card?.id ?? savedCard?.token ?? savedCard?.id;
    const lastFour = card?.last_four ?? card?.last4 ?? savedCard?.last_four ?? savedCard?.last4;
    const cardType = card?.card_type ?? card?.cardType ?? savedCard?.card_type ?? savedCard?.cardType ?? "Card";
    const cardName = card?.name ?? savedCard?.name ?? "Guest";
    const stripeToken = card?.stripe_token ?? savedCard?.stripe_token;

    if (cardToken) {
      const sessionCard = {
        token: cardToken,
        last4: lastFour,
        cardType,
        name: cardName,
        binType: card?.bin_type ?? card?.binType ?? savedCard?.bin_type ?? savedCard?.binType ?? 'credit',
        stripe_token: stripeToken ?? cardToken
      };
      this.setState((prev) => ({
        sessionCreditCards: [...(prev.sessionCreditCards || []), sessionCard],
        paymentSelection: "credit_card",
        transaction: { ...prev.transaction, card_token: cardToken, payment_type: "credit_card" },
        new_card: {
          stripe_token: stripeToken ?? cardToken,
          last_four: lastFour,
          name: sessionCard.name
        }
      }));
    }
    this.toggleStripeModal();
  };

  handleSubmitNewPropayBank = values => {
    this.setState(
      {
        new_bank: values
      },
      this.handleSubmit
    );
  };

  handleSubmit = () => {
    const component = this;
    const { customAmount, new_bank, paymentSelection } = this.state;
    const validateErrors = this.validate();
    const {
      rental,
      openLoadingSpinner,
      closeLoadingSpinner,
      onPaymentSuccess,
      location,
    } = this.props;
    const cardTypes = ['new_credit_card', 'credit_card'];
    const bankTypes = ['new_bank', 'bank'];
    let transactionObject;
    let cardTypeError;
    let newBankErrors;
    let bankTypeErrors;
    let paymentMethodType = document.getElementsByName("payment_method_type")[0]?.value;
    let checkType;
    let companyName;
    const paymentProcessor = rental?.paymentProcessor;

    if (cardTypes.includes(paymentSelection)) {
      transactionObject = this.buildCardRailsObject();
      cardTypeError = this.validateCardType(paymentMethodType)
    } else if (bankTypes.includes(paymentSelection)) {
      if (paymentSelection === 'new_bank' && paymentProcessor !== 'stripe') {
        newBankErrors = this.validateNewBank(new_bank)
      }
      transactionObject = this.buildBankRailsObject();
      checkType = document.getElementsByName("check_type")[0]?.value;
      companyName = document.getElementsByName("company_name")[0]?.value;
      bankTypeErrors = this.validateBankType(paymentMethodType, checkType, companyName);
    }
    const { transaction } = transactionObject;
    const merchantAccountErrors = this.validateMerchantAccount(location, paymentProcessor);
    const transactionAmountAndTypeErrors = this.validateTransactionAmountAndType(transaction, customAmount);
    const paymentValidationErrors = this.validatePayments(transaction, location, paymentProcessor)
    const errors = {
      ...validateErrors,
      ...merchantAccountErrors,
      ...transactionAmountAndTypeErrors,
      ...newBankErrors,
      ...cardTypeError,
      ...bankTypeErrors,
      ...paymentValidationErrors
    }
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors: errors
      });
      const { setErrors } = this.props;
      setErrors(errors);
    } else {
      openLoadingSpinner(
        "Processing payment... Please do not refresh or navigate away from this page."
      );
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN +
          "/api/portal/rentals/" +
          rental.token +
          "/transactions",
          this.buildRailsObject()
        )
        .then(response => {
          closeLoadingSpinner();
          onPaymentSuccess(response.data.transaction);
          component.setState({
            successOpen: true,
            open: false,
            errors: {}
          });
        })
        .catch(error => {
          console.log(error);
          const errors = error.response.data;
          const { setErrors } = this.props;
          closeLoadingSpinner();
          setErrors(errors);
          component.setState({
            errors: errors
          });
        });
    }
  };

  handleSuccessClose = () => {
    this.setState({
      successOpen: false
    });
  };

  handleAmountTypeChange = event => {
    const newAmountType = event.target.value;
    this.setState({
      amountType: newAmountType,
      customAmount: this.getPaymentAmount(newAmountType)
    });
  };

  getPaymentAmount = amountType => {
    const { rental } = this.props;
    const amountDue = rental.hasDeposit
      ? 0
      : Number(rental.minimumDeposit) - Number(rental.paymentBalance);
    switch (amountType) {
      case "amountDue":
        return amountDue;
      case "amountRemaining":
        return rental.amountRemaining;
      case "custom":
        return this.state.customAmount;
      default:
        return 0;
    }
  };

  renderCreditCardFee = () => {
    const { creditCardPercent } = this.props;
    const { paymentSelection, customAmount } = this.state;
    const percent = creditCardPercent / 100.0;
    const { location } = this.props;
    const shouldShowFee = location.chargeCreditCardFee;

    if (paymentSelection === "new_credit_card" && percent > 0 && shouldShowFee) {
      if (customAmount) {
        const newAmount = Number(customAmount) * percent;
        return (
          <p>
            You will be charged{" "}
            <CurrencyLabel
              value={newAmount}
            />{" "}
            for credit card fees.
          </p>
        );
      } else {
        return (
          <p>
            You will be charged{" "}
            <FormattedNumber
              value={percent || 0}
              // eslint-disable-next-line react/style-prop-object
              style="percent"
              minimumFractionDigits={2}
              minimumSignificantDigits={3}
            />{" "}
            for credit card fees.
          </p>
        );
      }
    } else {
      return null;
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: toNumber(value)
    });
  };

  guestCheckoutPrimaryContact() {
    const { rental } = this.props;
    let primaryContact;
    if (rental.companyRentalRelationship == null) {
      primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true);
    } else if (rental.companyRentalRelationship.isPrimaryContact == true) {
      primaryContact = rental.companyRentalRelationship;
    } else {
      primaryContact = rental.customerRentalRelationships.find((cr) => cr.isPrimaryContact == true);
    }
    return primaryContact;
  }

  renderNewCreditCardSection() {
    const { rental, location } = this.props;
    const { worldpayModalOpen, stripeModalOpen, cardNickname } = this.state;
    const primaryContact = this.guestCheckoutPrimaryContact();
    const customerId = primaryContact?.clientId ? primaryContact?.clientId : primaryContact?.companyId;
    const customerTypeValue = primaryContact?.clientType ? primaryContact?.clientType : "Company";

    switch (rental.paymentProcessor) {
      case "worldpay":
      case "launchpay":
        return (
          <div>
            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="card-nickname" style={{ display: "block", marginBottom: "5px", fontWeight: "normal" }}>
                Nickname for Card (optional)
              </label>
              <input
                id="card-nickname"
                type="text"
                maxLength={10}
                placeholder="Nickname for Card (i.e., 'Work')"
                value={cardNickname}
                onChange={(e) => this.setState({ cardNickname: e.target.value })}
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                }}
              />
            </div>
            <button
              type="button"
              className="btn full"
              onClick={this.toggleWorldpayModal}
              style={{ marginBottom: "15px" }}
            >
              Add Credit Card Securely
            </button>
            <WorldpayHostedPaymentModal
              open={worldpayModalOpen}
              toggle={this.toggleWorldpayModal}
              title="Add Credit Card"
              location={location}
              customerId={customerId}
              customerType={customerTypeValue}
              guestPayment
              nickname={cardNickname}
              onCardSaved={this.handleWorldpayCardSaved}
              onError={(error) => {
                this.props.setErrors({ body: error });
              }}
            />
            <p style={{ marginTop: "15px", marginBottom: "15px" }}>
              By clicking &quot;Add Credit Card Securely,&quot; you authorize us to securely store your encrypted payment card on
              file for future charges and orders.
            </p>
          </div>
        );
      case "stripe":
        return (
          <div>
            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="card-nickname-stripe" style={{ display: "block", marginBottom: "5px", fontWeight: "normal" }}>
                Nickname for Card (optional)
              </label>
              <input
                id="card-nickname-stripe"
                type="text"
                maxLength={10}
                placeholder="Nickname for Card (i.e., 'Work')"
                value={cardNickname}
                onChange={(e) => this.setState({ cardNickname: e.target.value })}
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                }}
              />
            </div>
            <button
              type="button"
              className="btn full"
              onClick={this.toggleStripeModal}
              style={{ marginBottom: "15px" }}
            >
              Add Credit Card Securely
            </button>
            <StripeSecureCardModal
              open={stripeModalOpen}
              toggle={this.toggleStripeModal}
              title="Add Credit Card"
              location={location}
              customerId={customerId}
              customerType={customerTypeValue}
              guestPayment
              nickname={cardNickname}
              onCardSaved={this.handleStripeCardSaved}
              onError={(error) => {
                this.props.setErrors({ body: error });
              }}
            />
            <p style={{ marginTop: "15px", marginBottom: "15px" }}>
              By clicking &quot;Add Credit Card Securely,&quot; you authorize us to securely store your encrypted payment card on
              file for future charges and orders.
            </p>
          </div>
        );
      default:
        return null;
    }
  }

  getSurchargeAmount = () => {
    const { paymentSelection, transaction, amountType, sessionCreditCards } = this.state;
    const { location, creditCardPercent, rental } = this.props;
    const isCardPayment = paymentSelection === 'credit_card' || paymentSelection === 'new_credit_card';
    if (!isCardPayment || !location.chargeCreditCardFee || !rental?.rentalSetting?.applyCcFee || creditCardPercent <= 0) {
      return 0;
    }
    const isCardSelected = paymentSelection === 'credit_card'
      && transaction.card_token
      && transaction.card_token !== 'new_credit_card';
    let isCreditBinType = true;
    if (isCardSelected && sessionCreditCards) {
      const selectedCard = sessionCreditCards.find((cc) => cc.token === transaction.card_token);
      if (selectedCard) {
        isCreditBinType = selectedCard.binType === 'credit';
      }
    }
    if (!isCreditBinType) return 0;
    const amount = Number(this.getPaymentAmount(amountType)) || 0;
    return (creditCardPercent / 100) * amount;
  };

  handleEditAmount = () => {
    this.setState({
      paymentSelection: 'new_credit_card',
      transaction: {
        ...this.state.transaction,
        card_token: '',
        payment_type: 'new_credit_card',
      },
      new_card: null,
    });
  };

  isPropayInUSA = (rental, location) => rental.paymentProcessor === "propay" && location.propayCountry === "USA";
  isWorldpayOrLaunchpayWithAchqData = (rental, location) => ['worldpay', 'launchpay'].includes(rental.paymentProcessor) && location.hasAchqData;

  render() {
    const {
      errors,
      paymentSelection,
      customAmount,
      amountType,
      transaction,
    } = this.state;
    const { location, rental, creditCardPercent } = this.props;
    return (
      <section className="connectPaymentBox">
        <div className="summary">
          <MakeAPayment />
          <h4>{rental.locationName}</h4>
          <div className="billingDetails">
            {!rental.hasDeposit && rental.minimumDeposit !== "" && (
              <div>
                <label>Minimum Deposit</label>
                <CurrencyLabel
                  value={
                    Number(rental.minimumDeposit) -
                    Number(rental.paymentBalance)
                  }
                />
              </div>
            )}
            {(() => {
              const isCardPayment = paymentSelection === 'credit_card' || paymentSelection === 'new_credit_card';
              const showSurcharge = isCardPayment
                && location.chargeCreditCardFee
                && rental?.rentalSetting?.applyCcFee
                && creditCardPercent > 0;
              const surchargeAmount = this.getSurchargeAmount();
              const isCardSelected = paymentSelection === 'credit_card'
                && transaction.card_token
                && transaction.card_token !== 'new_credit_card';
              const isConfirmedDebit = isCardSelected && surchargeAmount === 0;
              const hasSurchargeRows = showSurcharge && !isConfirmedDebit;
              return (
                <>
                  <div>
                    <label>{hasSurchargeRows ? 'Payment Subtotal' : 'Payment Total'}</label>
                    <CurrencyLabel value={this.getPaymentAmount(amountType)} />
                  </div>
                  {hasSurchargeRows && (
                    <>
                      <div>
                        <label>{isCardSelected ? 'CC Surcharge' : 'CC Surcharge Estimate'}</label>
                        <span>{!isCardSelected && '~'}<CurrencyLabel value={surchargeAmount} /></span>
                      </div>
                      <div style={{ borderTop: '2px solid currentColor', paddingTop: '5px' }}>
                        <label>Payment Total</label>
                        <CurrencyLabel value={(Number(this.getPaymentAmount(amountType)) || 0) + surchargeAmount} />
                      </div>
                    </>
                  )}
                </>
              );
            })()}
          </div>
          {rental?.rentalSetting?.applyCcFee && (
            <div className="desktopSurchargeNotice" style={{ marginTop: '40px' }}>
              <SurchargeNotice kind="action" />
            </div>
          )}
        </div>
        <ScrollArea speed={0.8} horizontal={false}>
          <div className="details">
            <div className="fields amount">
              <label>Payment Amount</label>
              {(() => {
                const paymentMethodSelected =
                  paymentSelection === 'credit_card' &&
                  transaction.card_token &&
                  transaction.card_token !== 'new_credit_card';
                const currentAmount = this.getPaymentAmount(amountType);
                if (paymentMethodSelected) {
                  return (
                    <p style={{ margin: 0 }}>
                      Pay: <CurrencyLabel value={currentAmount} />{' '}
                      <a
                        href='#'
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleEditAmount();
                        }}
                        style={{ color: '#007cba', textDecoration: 'underline' }}
                      >
                        Edit
                      </a>
                    </p>
                  );
                }
                return (
                  <>
                    <RadioGroup
                      name="amountType"
                      className="radioList"
                      value={amountType}
                      onChange={this.handleAmountTypeChange}
                    >
                      <FormControlLabel
                        label="Amount Due"
                        value="amountRemaining"
                        control={<Radio />}
                      />
                      <FormControlLabel
                        label="Minimum Deposit to Reserve"
                        value="amountDue"
                        control={<Radio />}
                      />
                      <FormControlLabel
                        label="Custom Amount"
                        value="custom"
                        control={<Radio />}
                      />
                    </RadioGroup>
                    <strong>
                      <CurrencyLabel value={this.getPaymentAmount("amountRemaining")} />
                    </strong>
                    <strong>
                      <CurrencyLabel value={this.getPaymentAmount("amountDue")} />
                    </strong>
                    <CurrencyInput
                      name="customAmount"
                      type="text"
                      placeholder="0.00"
                      className={classnames({ med: true, error: errors.amount })}
                      value={customAmount}
                      onChange={this.handleChange}
                    />
                  </>
                );
              })()}
            </div>
            <div className="fields">
              <label>Method of Payment</label>
              <div className="paymentMethodRow">
                <RadioGroup
                  name="paymentSelection"
                  className="radioList"
                  onChange={this.handleChange}
                  value={paymentSelection === "credit_card" ? "new_credit_card" : paymentSelection}
                  style={{ flex: 'none' }}
                >
                  <FormControlLabel
                    value="new_credit_card"
                    control={<Radio />}
                    label="Credit Card"
                  />

                  {(this.isPropayInUSA(rental, location) || this.isWorldpayOrLaunchpayWithAchqData(rental, location)) &&
                    (
                      <FormControlLabel
                        value="new_bank"
                        control={<Radio />}
                        label="Bank Account"
                      />
                    )}
                </RadioGroup>
                {location.chargeCreditCardFee && rental?.rentalSetting?.applyCcFee && creditCardPercent > 0
                  && (paymentSelection === 'new_credit_card' || paymentSelection === 'credit_card')
                  && (() => {
                    const surchargeAmount = this.getSurchargeAmount();
                    const isCardSelected = paymentSelection === 'credit_card'
                      && transaction.card_token
                      && transaction.card_token !== 'new_credit_card';
                    if (isCardSelected && surchargeAmount === 0) return null;
                    return (
                      <span className="paymentSurchargeHint">
                        (+<CurrencyLabel value={surchargeAmount} /> {isCardSelected ? 'Surcharge' : 'Estimated Surcharge'})
                      </span>
                    );
                  })()}
              </div>
            </div>
            <div className="fields">
              {(paymentSelection === "new_credit_card" || paymentSelection === "credit_card") && ["worldpay", "launchpay", "stripe"].includes(rental.paymentProcessor) && (
                <>
                  <label>Pay Using</label>
                  <StandardSelectField
                    meta={{}}
                    input={{
                      name: "card_token",
                      value: this.state.transaction?.card_token || "new_credit_card",
                      onChange: this.handleTransactionChange
                    }}
                  >
                    <option value="new_credit_card">New Credit Card</option>
                    {(this.state.sessionCreditCards || []).map((c) => (
                      <option key={c.token} value={c.token}>
                        {c.cardType} ****{c.last4}
                      </option>
                    ))}
                  </StandardSelectField>
                </>
              )}

              {paymentSelection === "credit_card" && (this.state.sessionCreditCards || []).length > 0 && (() => {
                const selected = (this.state.sessionCreditCards || []).find((c) => c.token === this.state.transaction?.card_token);
                if (!selected) return null;
                const amount = Number(this.getPaymentAmount(amountType)) || 0;
                const total = amount + this.getSurchargeAmount();
                return (
                  <div style={{ marginBottom: "15px" }}>
                    <p style={{ marginTop: '15px', marginBottom: '15px' }}>
                      By clicking "Make Payment," you authorize us to securely
                      store your encrypted payment card on file for future charges and orders.
                    </p>
                    <button type="button" className="btn full" onClick={this.handleSubmit}>
                      Submit Payment of <CurrencyLabel value={total} />
                    </button>
                  </div>
                );
              })()}

              {paymentSelection === "new_credit_card" && this.renderNewCreditCardSection()}

              {paymentSelection === "new_bank" &&
                rental.paymentProcessor === "propay" && (
                  <PropayBankForm
                    onSubmit={this.handleSubmitNewPropayBank}
                    type="checkout"
                  />
                )}

              {paymentSelection === "new_bank" &&
                (rental.paymentProcessor === "worldpay" || rental.paymentProcessor === "launchpay") && location.hasGrailpayEnabled && (
                  <WorldpayBankForm
                    onSubmit={this.handleSubmitNewPropayBank}
                    type="checkout"
                  />
                )}
            </div>
            <div className="mobileSurchargeNotice">
              {rental?.rentalSetting?.applyCcFee && <SurchargeNotice kind="action" />}
            </div>

          </div>
        </ScrollArea>

        <Modal
          open={this.state.successOpen}
          toggle={this.handleSuccessClose}
          title="Payment Confirmation"
          actions={[
            <a className="btn full" onClick={this.handleSuccessClose}>
              Ok
            </a>
          ]}
        >
          <p>Submitted payment was received</p>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const location = ownProps.location
    ? ownProps.location
    : state.locations.location;
  const customer = ownProps.customer
    ? ownProps.customer
    : state.customer.customer;
  const customerType = ownProps.customerType
    ? ownProps.customerType
    : state.guestCheckout.customerType;

  const creditCardPercent = location.creditCardPercent;

  return { creditCardPercent, location, customer, customerType };
};

export default connect(mapStateToProps, actions)(ConnectPaymentBox);
